import { render, staticRenderFns } from "./WindsorKinetics.vue?vue&type=template&id=0f5b3b4d&"
import script from "./WindsorKinetics.vue?vue&type=script&lang=js&"
export * from "./WindsorKinetics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports